import React, { Component, useEffect, useRef } from 'react';
import { Tree } from 'react-arborist';
import { isFlatTree, flatOpenIds } from './treeUtils';
import { ListGroup, ListGroupItem, FormGroup, Form, Label, Input, Col, Button } from 'reactstrap';
import chevronDown from '../assets/chevron-down.svg';
import chevronRight from '../assets/chevron-right.svg';
import filterIcon from '../assets/funnel-fill.svg';
import sortIcon from '../assets/sort.svg';
import reloadIcon from '../assets/arrow-clockwise.svg';
import exclamationIcon from '../assets/exclamation-fill.svg';
import locIcon from '../assets/location-pin.svg';
import pitIcon from '../assets/pit.png';
import benchIcon from '../assets/bench.png';
import shotIcon from '../assets/shot.png';
import planIcon from '../assets/plan.svg';
import holeIcon from '../assets/hole.svg';


function contextMenu(node, e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.setSelectedId(e.target.id);
    this.setState({ showContext: true, contextX: e.pageX, contextY: e.pageY, contextID: e.target.id, contextNode: node });


    const handleClick = () => {
        this.setState({ showContext: false, contextID: null });
        document.removeEventListener("click", handleClick);
    }
    document.addEventListener("click", handleClick);
}

function Node({ node, style, dragHandle }) {
    var selstyle = { ...style, cursor: 'pointer' };

    if (node.isSelected) {
        selstyle = { ...selstyle, fontWeight: 'bold' };
    }

    if (node.data?.id?.includes("reviewRequired")) {
        selstyle = { ...selstyle, color: '#EC6519' };
    }

    if (node.data?.archived) {
        selstyle = { ...selstyle, color: '#888888' };
    }

    var icon = <></>;
    if (node.isOpen) {
        icon = <img id={node.id} style={{ paddingRight: '2px', paddingBottom: '2px' }} src={chevronDown} />
    } else if (!node.isLeaf) {
        icon = <img id={node.id} style={{ paddingRight: '2px', paddingBottom: '2px' }} src={chevronRight} />
    }

    var type = node.data?.id?.split("-")[0];
    if (type == "loc") {
        icon = <>{icon} <img id={node.id} style={{ paddingRight: '2px', paddingBottom: '2px' }} src={locIcon} /></>
    } else if (type == "subloc") {
        icon = <>{icon} <img id={node.id} style={{ paddingRight: '2px', paddingBottom: '2px' }} src={pitIcon} /></>
    } else if (type == "seq") {
        icon = <>{icon} <img id={node.id} style={{ paddingRight: '2px', paddingBottom: '2px' }} src={benchIcon} /></>
    } else if (type == "subseq") {
        icon = <>{icon} <img id={node.id} style={{ paddingRight: '2px', paddingBottom: '2px' }} src={shotIcon} /></>
    } else if (type == "group") {
        icon = <>{icon} <img id={node.id} style={{ paddingRight: '2px', paddingBottom: '2px' }} src={shotIcon} /></>
    } else if (type == "plan") {
        icon = <>{icon} <img id={node.id} style={{ paddingRight: '2px', paddingBottom: '2px' }} src={planIcon} /></>
    } else if (type == "dispatch") {
        icon = <>{icon} <img id={node.id} style={{ height: '20px', width: '20px', paddingRight: '2px', paddingBottom: '2px' }} src={holeIcon} /></>
    }

    return (
        <div id={node.id} style={selstyle} onContextMenu={contextMenu.bind(this, node)} onMouseDown={(e) => { if (e.button === 2) e.stopPropagation(); }}>
            {icon}{node.data.name}{this.props.showAdvanced && (" [" + node.id + "]")}{this.props.showAdvanced && node.data.externalShotId && (" [extid-" + node.data.externalShotId + "]")}{node.data.archived ? " [archived]" : ""}{node.data?.id?.includes("reviewRequired") && <img id={node.id} style={{ height: '13px', width: '13px', marginLeft: '5px', marginBottom: '3px' }} src={exclamationIcon} />}{node.data?.id?.includes("potentialUnassigned") && <b> *</b>}
        </div>
    );
}

export class TreeView extends Component {
    resizeObserver = null;
    resizeElement = React.createRef();
    treeRef = React.createRef();
    lastAutoOpenKey = null;
    

    constructor(props) {
        super(props);

        this.state = {
            showContext: false,
            contextX: 0,
            contextY: 0,
            contextID: null,
            filter: null,
            filterShow: false,
            height: 500,
            width: 300,
            sortShow: false,
            sort: "alpha-asc"
        };
    }

    componentDidMount() {
        //const newHeight = this.divElement.clientHeight - this.formElement.clientHeight - 10;
        //const newWidth = this.divElement.clientWidth;
        //this.setState({ height: newHeight });
        //this.setState({ width: newWidth });

        this.resizeObserver = new ResizeObserver((entries) => {
            this.setState({ height: entries[0].contentBoxSize[0].blockSize - this.formElement.clientHeight - 10, width: entries[0].contentBoxSize[0].inlineSize });
        });

        this.resizeObserver.observe(this.resizeElement.current);
        this.autoOpenFlatGroups();
    }

    componentDidUpdate() {
        //const newHeight = this.divElement.clientHeight - this.formElement.clientHeight - 10;
        //const newWidth = this.divElement.clientWidth;
        //if (newHeight !== this.state.height) {
        //    this.setState({ height: newHeight });
        //}
        //if (newWidth !== this.state.width) {
        //    this.setState({ width: newWidth });
        //}
        this.autoOpenFlatGroups();
    }

    // Flat mode: expand the site root + "Shots"/"API" groups so shots are visible as soon
    // as a location's tree arrives. Keyed per location+shape so it fires once per tree —
    // a user collapsing a group isn't fought on every re-render — but re-fires when the
    // advanced toggle swaps classic back to flat, or the location changes.
    autoOpenFlatGroups() {
        var root = this.props.treeData?.[0];
        var openIds = flatOpenIds(this.props.treeData);
        var key = root ? root.id + (openIds ? "-flat" : "-classic") : null;
        if (key === this.lastAutoOpenKey) return;
        // quick-260810-jvd finding 8: on a flat tree, don't burn the one-shot key until the
        // react-arborist ref is actually attached — retry on the next componentDidUpdate
        // instead of silently giving up. Classic trees (openIds === null) have nothing to open,
        // so recording the key here is correct and prevents re-entry churn — bit-for-bit with
        // the pre-jvd classic behaviour.
        if (openIds && !this.treeRef.current) return;
        this.lastAutoOpenKey = key;
        if (openIds) {
            openIds.forEach((id) => this.treeRef.current.open(id));
        }
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    toggleConfigModal(option,id = -1, name = "") {
        this.setState({ showContext: false, contextID: null });
        this.props.toggleConfig(option,id,name);
    }

    togglePlanModal(option) {
        this.setState({ showContext: false, contextID: null });
        this.props.togglePlan(option);
    }

    nodeSelect(node) {
        if (node.length > 0) {
            if (node[0].data != null) {
                //console.log(node[0].data.id);
                var type = node[0].data.id.split("-")[0];
                var id = node[0].data.id.split("-")[1]
                if (type == "subloc") {
                    this.props.setSelectedSubLocation(id);
                } else if (type == "seq") {
                    this.props.setSelectedSequence(id);
                } else if (type == "subseq") {
                    this.props.setSelectedSubSequence(id);
                } else if (type == "plan") {
                    this.props.setSelectedPlan(id);
                } else if (type == "dispatch") {
                    this.props.setSelectedDispatch(id);
                }

                if (this.props.selectedId != node[0].data.id) {
                    this.props.setSelectedId(node[0].data.id);
                }
            }
            if (this.props.selectedId == node[0].data.id) {
                node[0].toggle();
            }
        }
    }

    deleteItem(ID) {
        this.props.deleteItem(ID);
    }

    archiveItem(ID) {
        this.props.archiveItem(ID);
    }

    unarchiveItem(ID) {
        this.props.unarchiveItem(ID);
    }

    contextMenuElement() {
        if (this.state.contextID != null) {
            var type = this.state.contextID.split("-")[0];
            var id = this.state.contextID.split("-")[1];

            var elements = [];
            var isApiManaged = this.state.contextNode.data.isApiManaged;
            if (!this.state.contextNode.data.archived) { //only allow adding if NOT archived
                if (type == 'loc') {
                    // Flat mode hides pits, so pit creation is advanced-only there: shots go in
                    // via the "Shots" group; ticking Advanced Options fetches the classic tree.
                    if (!isFlatTree(this.props.treeData) || this.props.showAdvanced) {
                        elements.push(<ListGroupItem action onClick={() => this.toggleConfigModal("subloc")}>Add New Pit</ListGroupItem>);
                    }
                    if (this.props.showAdvanced) { elements.push(<ListGroupItem action onClick={() => this.props.refreshTolerances(this.state.contextID)}>Refresh Dispatch Tolerances</ListGroupItem>); }
                } else if (type == 'subloc') {
                    //elements.push(<ListGroupItem action onClick={() => this.toggleConfigModal("subloc")}>Add New Pit</ListGroupItem>);
                    if (!isApiManaged || this.props.showAdvanced) {
                        elements.push(<ListGroupItem action onClick={() => this.toggleConfigModal("seq")}>Add New RL</ListGroupItem>);
                    }
                } else if (type == 'seq') {
                    //elements.push(<ListGroupItem action onClick={() => this.toggleConfigModal("seq")}>Add New RL</ListGroupItem>);
                    if (!isApiManaged || this.props.showAdvanced) {
                        elements.push(<ListGroupItem action onClick={() => this.toggleConfigModal("subseq")}>Add New Shot</ListGroupItem>);
                    }
                } else if (type == 'group') {
                    // quick-260810-dqw D-04: flat-mode "Shots" group -> lazily-created default
                    // pit/RL. toggleConfigModal defaults id = -1, which is what makes
                    // configSubsequenceInsertOrUpdate take the insert branch.
                    elements.push(<ListGroupItem action onClick={() => this.toggleConfigModal("subseqflat")}>Add New Shot</ListGroupItem>);
                } else if (type == 'subseq') {
                    //elements.push(<ListGroupItem action onClick={() => this.toggleConfigModal("subseq")}>Add New Shot</ListGroupItem>);
                    if (this.state.contextNode.data.children.length == 0 || this.props.showAdvanced) { //can only add 1 plan
                        if (!isApiManaged || this.props.showAdvanced) {
                            elements.push(<ListGroupItem action onClick={() => this.togglePlanModal("new")}>Add New Plan</ListGroupItem>);
                        }
                    }
                } else if (type == 'plan' && !this.state.contextNode.parent.data.archived) { //plan uses archived status of parent
                    //elements.push(<ListGroupItem action onClick={() => this.togglePlanModal("update")}>Add Stem Heights</ListGroupItem>);
                    if (!this.state.contextNode.parent.data.isApiManaged || this.props.showAdvanced) {
                        elements.push(<ListGroupItem action onClick={() => this.togglePlanModal("update")}>Update Plan</ListGroupItem>);
                        if (this.props.locationOptions?.RedrillMode === "Explicit") {
                            elements.push(<ListGroupItem action onClick={() => this.togglePlanModal("redrill")}>Add Redrills</ListGroupItem>);
                        }
                    }
                }
            }

            this.state.contextNode.data.actions?.forEach((action) => {
                if (action == "Delete") {
                    if (!isApiManaged || this.props.showAdvanced) {
                        elements.push(<ListGroupItem action onClick={() => this.deleteItem(this.state.contextID)}>Delete</ListGroupItem>);
                    }
                } else if (action == "Archive") {
                    if (!isApiManaged || this.props.showAdvanced) {
                        elements.push(<ListGroupItem action onClick={() => this.archiveItem(this.state.contextID)}>Archive</ListGroupItem>);
                    }
                } else if (action == "Unarchive") {
                    if (!isApiManaged || this.props.showAdvanced) {
                        elements.push(<ListGroupItem action onClick={() => this.unarchiveItem(this.state.contextID)}>Unarchive</ListGroupItem>);
                    }
                }
            });

            if (!this.state.contextNode.data.archived && (type == 'subloc' || type == 'seq' || type == 'subseq')) { //only rename if NOT archived
                if (!isApiManaged || this.props.showAdvanced) {
                    // Flat mode opens shot renames as 'subseqflat' so the modal uses the flat submit
                    // gate (no unreachable loadingsequence flag — same deadlock as the fixed Create
                    // bug). Rename routing is unaffected: configId != -1 always hits
                    // postsubsequenceUpdateName regardless of configOption.
                    var renameOption = (type == 'subseq' && isFlatTree(this.props.treeData)) ? 'subseqflat' : type;
                    elements.push(<ListGroupItem action onClick={() => this.toggleConfigModal(renameOption, id, this.state.contextNode.data.name)}>Rename</ListGroupItem>);
                }
            }

            return (<div style={{ position: 'fixed', minWidth: '170px', width: 'max-content', maxWidth: '280px', whiteSpace: 'normal', borderRadius: '5px', boxShadow: '0 2px 8px rgba(0,0,0,0.15)', zIndex: 1050, top: this.state.contextY + "px", left: this.state.contextX + "px" }}><ListGroup>{elements}</ListGroup></div>);
        } else {
            return (<></>);
        }
    }

    handleFilterChange(e) {
        this.setState({ filter: e.target.value });
    }

    toggleFilter() {
        this.setState({ filterShow: !this.state.filterShow });
    }

    toggleSort() {
        this.setState({ sortShow: !this.state.sortShow });
    }

    handleSortChange(e) {
        this.setState({ sort: e.target.value });
        this.props.updateSort(e.target.value);
    }
    

    render() {
        const contextMenu = this.contextMenuElement();

        return (
            <div style={{ height: '100%', whiteSpace: 'nowrap' }} ref={this.resizeElement} >
                <div ref={(formElement) => { this.formElement = formElement }}>
                <Form style={{ paddingTop: "5px" }} id='sidebar-controls' >
                    <FormGroup row style={{ marginBottom: 0 }}>
                        <Col sm={4}>
                            <div style={{ fontWeight: 500, color: '#123241', textAlign: 'center', cursor: 'pointer' }} onClick={this.toggleFilter.bind(this)}><img src={filterIcon} style={{ marginBottom: '3px', paddingRight: '2px' }}/>Filter</div>
                        </Col>
                        <Col sm={4}>
                            <div style={{ fontWeight: 500, color: '#123241', textAlign: 'center', cursor: 'pointer' }} onClick={this.toggleSort.bind(this)}><img src={sortIcon} style={{ marginBottom: '3px', paddingRight: '2px' }} />Sort</div>
                        </Col>
                        <Col sm={4}>
                            <div style={{ fontWeight: 500, color: '#123241', textAlign: 'center', cursor: 'pointer' }} onClick={this.props.refreshData}><img src={reloadIcon} style={{ marginBottom: '3px', paddingRight: '2px'}}/>Refresh</div>
                        </Col>
                    </FormGroup>
                        {this.state.filterShow && <FormGroup row style={{ marginBottom: 0, marginRight: 0}}>
                        <Col sm={12}>
                            <Input id="filter" name="filter" onChange={this.handleFilterChange.bind(this)} />
                        </Col>
                        </FormGroup>}
                        {this.state.sortShow && <FormGroup row style={{ marginBottom: 0 }}>
                            <Col sm={12}>
                                <Input id="sort" name="sort" type="select" onChange={this.handleSortChange.bind(this)} value={this.state.sort}>
                                    <option value="alpha-asc">Alphabetical: Asc</option>
                                    <option value="alpha-desc">Alphabetical: Desc</option>
                                    <option value="created-asc">Created: Asc</option>
                                    <option value="created-desc">Created: Desc</option>
                                </Input>
                            </Col>
                        </FormGroup>}
                    </Form>
                </div>
                <div ref={(treeElement) => { this.treeElement = treeElement }}>
                    <Tree ref={this.treeRef} width={this.state.width} height={this.state.height} data={this.props.treeData} disableDrag={true} disableDrop={true} onSelect={this.nodeSelect.bind(this)} searchTerm={this.state.filter} openByDefault={false} selection={this.props.selectedId}>
                    {Node.bind(this)}
                    </Tree>
                </div>

                { this.state.showContext && contextMenu }
            </div>
        );
    }
}